import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { Platform } from 'root/src/shared/@types/platforms';
import { PublisherBanListType } from 'root/src/shared/@types/publisherBanList';
import { publisherListsEndpointIds } from 'root/src/shared/publisherLists/publisherLists.constants';
export const removePublisherBannedCreatorsEndpoint = {
    [publisherListsEndpointIds.REMOVE_PUBLISHER_BANNED_CREATORS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.brand,
        payloadSchema: {
            type: 'object',
            properties: {
                creators: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            platform: {
                                type: 'string',
                                enum: Object.values(Platform),
                            },
                            platformId: {
                                type: 'string',
                            },
                        },
                    },
                },
                banListType: {
                    type: 'string',
                    enum: Object.values(PublisherBanListType),
                },
                dropEventId: {
                    type: 'string',
                },
            },
            required: ['creators', 'banListType'],
        },
    },
};
